import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';

export const passportGroupIsExistsGroupsForCancellationSelector = (state: IRootState) =>
  state.passportGroup.isExistsGroupsForCancellation;
export const passportGroupListSelector = (state: IRootState) => state.passportGroup.passportGroupList;
export const passportGroupListTotalCountSelector = (state: IRootState) =>
  state.passportGroup.passportGroupListTotalCount;
export const passportGroupListCurrentPageSelector = (state: IRootState) =>
  state.passportGroup.passportGroupListCurrentPage;
export const passportGroupPassportListSelector = (state: IRootState) => state.passportGroup.passportGroupPassportList;
export const passportGroupPassportListCurrentPageSelector = (state: IRootState) =>
  state.passportGroup.passportGroupPassportListCurrentPage;
export const passportGroupPassportListTotalCount = (state: IRootState) =>
  state.passportGroup.passportGroupPassportListTotalCount;
export const passportGroupSelector = (state: IRootState) => state.passportGroup.passportGroup;
export const passportGroupInitFormSelector = (state: IRootState) => state.passportGroup.passportGroupInitForm;
export const passportGroupApplySuccessSelector = (state: IRootState) => state.passportGroup.applySuccess;
export const passportGroupCreateSuccessSelector = (state: IRootState) => state.passportGroup.passportGroupCreateSuccess;
export const passportGroupNoticeSelector = (state: IRootState) => state.passportGroup.notice;
export const passportGroupIsDeletedSelector = (state: IRootState) => state.passportGroup.isDeleted;
